import { render, staticRenderFns } from "./CalendarImportDialog.vue?vue&type=template&id=bd8e1928&scoped=true&"
import script from "./CalendarImportDialog.vue?vue&type=script&lang=ts&"
export * from "./CalendarImportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8e1928",
  null
  
)

export default component.exports